(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-secondary"] && !Shopify.designMode) return;
  try {
    
  const announcement = document.querySelector('.announcement-bar-secondary-content a');
  const elementWidth = announcement.offsetWidth;
  window.addEventListener('resize', () => {
    //console.log(window.innerWidth + ' ' + elementWidth);
    if (window.innerWidth < elementWidth + 100) {
      announcement.classList.add('scroll');
    } else {
      announcement.classList.remove('scroll');
    }
  });

  function switchSubdomain(subdomain, barColorClass) {
      const subdomainUrls = {
          subdomain1: 'https://industrial.cherygroup.ca',
          subdomain2: 'https://equipment.cherygroup.ca',
          subdomain3: 'https://logistics.cherygroup.ca',
          subdomain4: 'https://mart.cherygroup.ca'
      };

      document.getElementById('top-bar').className = barColorClass;

      window.location.href = subdomainUrls[subdomain];
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  document.addEventListener('change', async (event) => {
    const checkbox = event.target.closest('[data-expedited-delivery]');

    if (!checkbox) return;

    const checkoutButton = document.querySelector('[data-cart-checkout]');
    const cartError = document.getElementById('cart-errors');
    const requested = checkbox.checked;
    const checkoutWasDisabled = checkoutButton?.disabled;

    checkbox.disabled = true;
    if (checkoutButton) checkoutButton.disabled = true;
    if (cartError) cartError.textContent = '';

    try {
      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          attributes: { 'Expedited delivery requested': requested ? 'Yes' : '' }
        })
      });
      const cart = await response.json();

      if (!response.ok || cart.errors) {
        throw new Error(checkbox.dataset.saveError);
      }
    } catch (error) {
      checkbox.checked = !requested;
      if (cartError) cartError.textContent = checkbox.dataset.saveError;
    } finally {
      checkbox.disabled = false;
      if (checkoutButton) checkoutButton.disabled = checkoutWasDisabled;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"]) return;
  try {
    
  function addIconClasses() {
    const icons = document.querySelectorAll('.faq.question-container > svg');
    for (let i = 0; i < icons.length; i++) {
      icons[i].classList.add('faq', 'question-icon');
      if (i % 2 != 0) icons[i].classList.add('hidden');
    }
  }
  function addDropdownAnimation() {
    const qaContainers = document.querySelectorAll('.faq.question-answer-container');
    qaContainers.forEach((qa) => {
      const question = qa.querySelector('.question-container');
      const answer = qa.querySelector('.answer');
      const icons = qa.querySelectorAll('.question-icon');
      question.addEventListener('click', () => {
        answer.classList.toggle('hidden');
        icons.forEach((icon) => {
          icon.classList.toggle('hidden');
        });
      });
    });
  }
  addIconClasses();
  addDropdownAnimation();

  } catch(e) { console.error(e); }
})();
})();
